<div class="alert" [class]="[alertClass, size]" [style.margin]="margin">
  @if (showIcon) {
    <div class="alert-icon">
      <ion-icon name="{{ icon }}"></ion-icon>
    </div>
  }
  <div class="alert-content">
    @if (title) {
      <h4 class="alert-title">{{ title }}</h4>
    }
    @if (description) {
      <p class="alert-description">{{ description }}</p>
    }
    @if (actionLabel) {
      <ion-button
        class="alert-action"
        fill="clear"
        size="small"
        (click)="actionClick.emit()"
      >
        {{ actionLabel }}
      </ion-button>
    }
  </div>
</div>
